import React from 'react';
import { Field } from 'react-final-form';

import RadioButtonInput from '../../inputs/RadioButton';

export const parseTrueFalseValue = value => value === 'true';

export default fieldProps => (
  <Field
    component={RadioButtonInput}
    type="radio"
    {...fieldProps}
  />
);
